import { OrderDetail } from "./orderDetail.ui";
import { OrderUpdateRequest } from "./orderUpdate.api";

export const ConvertOrderUpdateRequest = (order: OrderDetail): OrderUpdateRequest => {
    return {
        group_id: order.group_id,
        customer_code: order.customer_code,
        branch_code: order.branch_code,
        line_id: order.line_id,
        type: order.type,
        sales_date: order.sales_date,
        order_items: order.order_items?.filter((item) => item.is_selected).map((item) => {
            return {
                product_code: item.product_code,
                product_name: item.product_name,
                origin_code: item.origin_code,
                origin_name: item.origin_name,
                shipper_code: item.shipper_code,
                shipper_name: item.shipper_name,
                grade: item.grade,
                rank: item.rank,
                order_unit: item.order_unit,
                order_quantity: item.order_quantity,
                weight: item.weight,
                package_type: item.package_type,
                quantity_per_package: item.quantity_per_package,
                proposed_price: item.proposed_price ? Number(item.proposed_price) : undefined,
                line_total: item.line_total ? Number(item.line_total) : undefined,
                notes: item.notes,
                daily_note: item.created_at?.toString(),
                weekly_note: item.updated_at?.toString(),
            }
        }),

    }
}